export default "__VITE_ASSET__DbQMMMCg__"